import React from 'react';

import CommonBanner from './CommonGoogleAdBanner';

const HomeRightScrollUp = ({ data }) => {
  return <CommonBanner data={data} typePosition="home_right_scroll_up" />;
};

export default HomeRightScrollUp;
